import React from 'react';
import styled, { css } from 'styled-components';
import { Flex, Box } from 'rebass';
import AspectRatio from '../../../AspectRatio';
import { getDate } from 'date-fns';
import Text from '../../../Text';

const Layout = styled(AspectRatio).attrs(() => ({
  width: 1,
  height: 1,
}))`
  ${({ theme }) => css`
    border-bottom: ${theme.border};
    border-right: ${theme.border};
    min-width: 24px;
    width: 100%;
    position: relative;
  `}
`;

const Inner = styled(Flex)`
  flex-direction: column;
  height: 100%;
`;

const CalendarDay = ({ value, children, ...props }) => {
  return (
    <Layout {...props}>
      <Inner>
        <Box p={2}>
          <Text variant="secondary">{getDate(value)}</Text>
        </Box>
        <Box flex="1">{children}</Box>
      </Inner>
    </Layout>
  );
};

export default CalendarDay;
